import site from '../../site';
import actions from '../actions';

const viewStatusChanger = (store) => (next) => (action) => {
  if (action.type !== site.actionTypes.SET_ACTIVE_PAGE) return next(action);

  store.dispatch(actions.setLoadedStatus(false));
  return next(action);
};

export default viewStatusChanger;
